export enum AssignmentStatus {
  TODO = "todo",
  PENDING = "pending",
  MARKED = "marked",
  MARKS_NOT_AVAILABLE = "marks_not_available",
  EXEMPTED = "exempted",
  RESUBMISSION_REQUIRED = "resubmission_required"
}
